/* Serené — Fragrance Quiz Engine
   Vanilla JS, no dependencies. Mounts on elements with data-fragrance-quiz.
   Data model and scoring match SCORING.md (treat that doc as source of truth).

   Public API: the quiz auto-inits on DOMContentLoaded for every
   [data-fragrance-quiz] node it finds. Multiple instances on the same page
   are supported (each has its own state).
*/
(function () {
  "use strict";

  /* ======================================================================
     QUESTIONS — editable copy lives here. Options use stable `value` strings
     that the scoring engine keys off. Only edit labels/emoji unless you also
     update SCORING.md.
     ====================================================================== */
  const QUESTIONS = [
    {
      id: "genderFilter",
      kind: "single",
      title: "¿Qué colección te representa?",
      sub: "Elige la colección Serené que quieres explorar. Puedes volver a hacer el test con otra cuando quieras.",
      options: [
        { value: "mujeres",  label: "Para mujer",           hint: "Colección Femenina",        emoji: "🌸" },
        { value: "hombres",  label: "Para hombre",          hint: "Colección Masculina",       emoji: "🖤" },
        { value: "unisex",   label: "Unisex / sin preferencia", hint: "Aromas que trascienden género", emoji: "✨" },
      ],
    },
    {
      id: "climatePreference",
      kind: "single",
      title: "¿En qué clima la vas a usar?",
      sub: "Esto ayuda a encontrar una fragancia que brille en tu entorno.",
      options: [
        { value: "calido",    label: "Cálido",      hint: "Verano, playa, ciudad soleada", emoji: "☀️" },
        { value: "templado",  label: "Templado",    hint: "Primavera / otoño",            emoji: "🌤️" },
        { value: "frio",      label: "Frío",        hint: "Invierno, noches frías",       emoji: "❄️" },
        { value: "versatil",  label: "Algo versátil", hint: "Que sirva para cualquier clima", emoji: "🌀" },
      ],
    },
    {
      id: "scentPreference",
      kind: "multi",
      max: 3,
      title: "¿Qué perfil olfativo te enamora?",
      sub: "Elige hasta 3. Mientras más específico, mejor será tu match.",
      options: [
        { value: "dulce",     label: "Dulce",         emoji: "🍯" },
        { value: "fresca",    label: "Fresca",        emoji: "🌿" },
        { value: "floral",    label: "Floral",        emoji: "🌸" },
        { value: "citrica",   label: "Cítrica",       emoji: "🍊" },
        { value: "amaderada", label: "Amaderada",     emoji: "🌲" },
        { value: "limpia",    label: "Limpia / suave",emoji: "🫧" },
        { value: "intensa",   label: "Intensa / sensual", emoji: "🔥" },
        { value: "elegante",  label: "Elegante / sofisticada", emoji: "🖤" },
      ],
    },
    {
      id: "usageOccasion",
      kind: "single",
      title: "¿Para qué ocasión la quieres?",
      options: [
        { value: "diario",   label: "Diario",            emoji: "☕" },
        { value: "oficina",  label: "Oficina / universidad", emoji: "💼" },
        { value: "citas",    label: "Citas",             emoji: "💋" },
        { value: "noche",    label: "Salidas / noche",   emoji: "🌙" },
        { value: "eventos",  label: "Eventos especiales",emoji: "🥂" },
        { value: "versatil", label: "Todo terreno",      emoji: "✨" },
      ],
    },
    {
      id: "intensityPreference",
      kind: "single",
      title: "¿Qué tan intenso la quieres?",
      options: [
        { value: "suave",    label: "Suave",              hint: "Sutil y cercana",             emoji: "🕊️" },
        { value: "media",    label: "Media",              hint: "Se siente pero no satura",    emoji: "⚖️" },
        { value: "alta",     label: "Alta",               hint: "Se nota al entrar a un lugar",emoji: "⚡" },
        { value: "se_note",  label: "Quiero que se note", hint: "Estela fuerte y duradera",    emoji: "💥" },
      ],
    },
    {
      id: "personalityType",
      kind: "single",
      title: "¿Con cuál vibra te identificas más hoy?",
      sub: "Escoge la que mejor capture tu energía actual.",
      // Default options (mujeres / unisex). Used when gender is unset or "unisex".
      options: [
        { value: "delicada",               label: "Delicada",              emoji: "🤍" },
        { value: "segura_elegante",        label: "Segura y elegante",     emoji: "👑" },
        { value: "coqueta_dulce",          label: "Coqueta y dulce",       emoji: "💖" },
        { value: "fresca_relajada",        label: "Fresca y relajada",     emoji: "🌊" },
        { value: "sofisticada_misteriosa", label: "Sofisticada / misteriosa", emoji: "🔮" },
        { value: "poderosa_llamativa",     label: "Poderosa / llamativa",  emoji: "💋" },
      ],
      // Gender-specific overrides — same value keys where scoring already handles them,
      // new keys ("audaz_aventurero", "clasico_discreto") gracefully score 0 on personality
      // (10% weight) without affecting the gender-filtered scent/climate/occasion scores.
      optionsByGender: {
        mujeres: [
          { value: "delicada",               label: "Delicada",                 emoji: "🤍" },
          { value: "segura_elegante",        label: "Segura y elegante",        emoji: "👑" },
          { value: "coqueta_dulce",          label: "Coqueta y dulce",          emoji: "💖" },
          { value: "fresca_relajada",        label: "Fresca y relajada",        emoji: "🌊" },
          { value: "sofisticada_misteriosa", label: "Sofisticada / misteriosa", emoji: "🔮" },
          { value: "poderosa_llamativa",     label: "Poderosa / llamativa",     emoji: "💋" },
        ],
        hombres: [
          { value: "fresca_relajada",        label: "Fresco y relajado",        emoji: "🌊" },
          { value: "segura_elegante",        label: "Seguro y elegante",        emoji: "👑" },
          { value: "sofisticada_misteriosa", label: "Misterioso / profundo",    emoji: "🌑" },
          { value: "poderosa_llamativa",     label: "Intenso / llamativo",      emoji: "💥" },
          { value: "audaz_aventurero",       label: "Audaz / aventurero",       emoji: "🔥" },
          { value: "clasico_discreto",       label: "Clásico / discreto",       emoji: "🎩" },
        ],
        unisex: [
          { value: "fresca_relajada",        label: "Fresco/a y relajado/a",         emoji: "🌊" },
          { value: "segura_elegante",        label: "Seguro/a y elegante",           emoji: "👑" },
          { value: "sofisticada_misteriosa", label: "Sofisticado/a / misterioso/a",  emoji: "🔮" },
          { value: "poderosa_llamativa",     label: "Poderoso/a / llamativo/a",      emoji: "💥" },
          { value: "delicada",               label: "Delicado/a",                    emoji: "🤍" },
          { value: "audaz_aventurero",       label: "Audaz / aventurero/a",          emoji: "🔥" },
        ],
      },
    },
    {
      id: "dayMoment",
      kind: "single",
      title: "¿Cuándo la vas a usar más?",
      options: [
        { value: "dia",         label: "De día",       emoji: "🌞" },
        { value: "noche",       label: "De noche",     emoji: "🌚" },
        { value: "todo_el_dia", label: "Todo el día",  emoji: "🕐" },
        { value: "finde",       label: "Fines de semana", emoji: "🥳" },
      ],
    },
    {
      id: "purchaseIntent",
      kind: "single",
      title: "¿Qué quieres que pase cuando la uses?",
      options: [
        { value: "facil_usar",          label: "Quiero algo fácil de usar",              emoji: "🌱" },
        { value: "cumplidos",           label: "Quiero recibir cumplidos",               emoji: "💬" },
        { value: "distintivo",          label: "Quiero algo distintivo",                 emoji: "🪄" },
        { value: "lujoso",              label: "Quiero que huela a lujo",                emoji: "💎" },
        { value: "parecido_disenador",  label: "Quiero algo parecido a un diseñador",    emoji: "🏷️" },
      ],
    },
    {
      id: "explorationMode",
      kind: "single",
      title: "¿Cómo prefieres usar tus fragancias?",
      sub: "Esto nos ayuda a armar tu recomendación final.",
      options: [
        { value: "firma_unica",     label: "Quiero una sola firma",                       emoji: "🔒" },
        { value: "diario_especial", label: "Una para diario y otra para ocasiones especiales", emoji: "👯" },
        { value: "variar_mood",     label: "Me gusta variar según mi mood",               emoji: "🔄" },
      ],
    },
  ];

  /* ======================================================================
     SCORING — see SCORING.md
     ====================================================================== */
  const SCORING_WEIGHTS = {
    scent: 0.30, climate: 0.15, occasion: 0.15, intensity: 0.10,
    personality: 0.10, style: 0.05, daypart: 0.05, purchase_intent: 0.10,
  };

  const SCENT_TO_FAMILY = {
    dulce:     ["dulce_gourmand"],
    fresca:    ["fresca_aromatica", "citrica", "acuatica_marina"],
    floral:    ["floral"],
    citrica:   ["citrica"],
    amaderada: ["amaderada", "chipre"],
    limpia:    ["fresca_aromatica", "acuatica_marina"],
    intensa:   ["oriental_ambar", "cuero_tabaco", "especiada", "dulce_gourmand"],
    elegante:  ["amaderada", "chipre", "oriental_ambar", "floral"],
  };

  const FAMILY_ADJACENCY = {
    dulce_gourmand: ["oriental_ambar", "frutal", "especiada"],
    oriental_ambar: ["dulce_gourmand", "especiada", "cuero_tabaco"],
    especiada: ["oriental_ambar", "amaderada"],
    floral: ["frutal", "dulce_gourmand", "fresca_aromatica"],
    frutal: ["floral", "dulce_gourmand", "citrica"],
    citrica: ["fresca_aromatica", "acuatica_marina", "frutal"],
    fresca_aromatica: ["citrica", "acuatica_marina"],
    acuatica_marina: ["citrica", "fresca_aromatica"],
    amaderada: ["chipre", "cuero_tabaco", "especiada"],
    chipre: ["amaderada", "fresca_aromatica"],
    cuero_tabaco: ["amaderada", "oriental_ambar"],
    fougere: ["fresca_aromatica", "amaderada"],
  };

  const CLIMATE_ADJACENCY = {
    calido: ["templado"], templado: ["calido", "frio"], frio: ["templado"],
  };

  const OCCASION_RELATION = {
    diario:   ["oficina"],
    oficina:  ["diario"],
    citas:    ["noche", "eventos"],
    noche:    ["citas", "eventos", "salidas"],
    eventos:  ["citas", "noche"],
    versatil: ["diario", "oficina", "citas", "noche", "eventos"],
  };

  const INTENSITY_TARGET = { suave: 2, media: 3, alta: 4, se_note: 5 };

  function scoreScent(userScents, fam) {
    if (!userScents || !userScents.length) return 0.5;
    let best = 0;
    for (const tag of userScents) {
      const rewarded = SCENT_TO_FAMILY[tag] || [];
      if (rewarded.some(f => fam.includes(f))) { best = Math.max(best, 1.0); continue; }
      const adj = rewarded.flatMap(f => FAMILY_ADJACENCY[f] || []);
      if (adj.some(f => fam.includes(f))) best = Math.max(best, 0.5);
    }
    return best;
  }

  function scoreClimate(userClimate, fit) {
    if (userClimate === "versatil") return fit.length >= 2 ? 1.0 : 0.5;
    if (fit.includes(userClimate)) return 1.0;
    const adj = CLIMATE_ADJACENCY[userClimate] || [];
    if (adj.some(c => fit.includes(c))) return 0.5;
    return 0;
  }

  function scoreOccasion(userOcc, fit) {
    if (userOcc === "versatil") return 1.0;
    if (fit.includes(userOcc)) return 1.0;
    if (fit.includes("versatil")) return 1.0;
    const related = OCCASION_RELATION[userOcc] || [];
    if (related.some(o => fit.includes(o))) return 0.5;
    return 0;
  }

  function scoreIntensity(userIntensity, level) {
    const target = INTENSITY_TARGET[userIntensity] || 3;
    const diff = Math.abs(target - (level || 3));
    return Math.max(0, 1 - diff / 4);
  }

  function scorePersonality(userP, tags) {
    if (!tags || !tags.length) return 0.3;
    if (tags.includes(userP)) return 1.0;
    if (tags.includes("segura_elegante") || tags.includes("sofisticada_misteriosa")) return 0.5;
    return 0;
  }

  function scoreStyle(userS, tags) {
    if (!userS) return 0.5;
    if (!tags || !tags.length) return 0.3;
    if (tags.includes(userS)) return 1.0;
    if (tags.includes("clasica") || tags.includes("chic")) return 0.5;
    return 0;
  }

  function scoreDaypart(userD, fit) {
    if (userD === "dia")         return fit.includes("dia") ? 1.0 : 0.3;
    if (userD === "noche")       return fit.includes("noche") ? 1.0 : 0.3;
    if (userD === "todo_el_dia") return (fit.includes("dia") && fit.includes("noche")) ? 1.0 : 0.5;
    if (userD === "finde")       return fit.length >= 1 ? 0.8 : 0.5;
    return 0.5;
  }

  function scorePurchaseIntent(userI, f) {
    switch (userI) {
      case "facil_usar":         return (f.versatility_score >= 4 && f.intensity_level <= 3) ? 1.0 : 0.5;
      case "cumplidos":          return (f.compliment_factor >= 4) ? 1.0 : 0.5;
      case "distintivo":         return (f.luxury_factor >= 4 || (f.olfactory_family || []).some(x => ["oriental_ambar","cuero_tabaco"].includes(x))) ? 1.0 : 0.5;
      case "lujoso":             return (f.luxury_factor >= 4) ? 1.0 : 0.5;
      case "parecido_disenador": return f.inspiration_brand ? 1.0 : 0.6;
      default: return 0.5;
    }
  }

  function scoreFragrance(f, userProfile) {
    const s_scent     = scoreScent(userProfile.scentPreference, f.olfactory_family || []);
    const s_climate   = scoreClimate(userProfile.climatePreference, f.climate_fit || []);
    const s_occasion  = scoreOccasion(userProfile.usageOccasion, f.occasion_fit || []);
    const s_intensity = scoreIntensity(userProfile.intensityPreference, f.intensity_level);
    const s_person    = scorePersonality(userProfile.personalityType, f.personality_tags);
    const s_style     = scoreStyle(userProfile.styleType, f.style_tags);
    const s_daypart   = scoreDaypart(userProfile.dayMoment, f.day_night_fit || []);
    const s_intent    = scorePurchaseIntent(userProfile.purchaseIntent, f);

    const W = SCORING_WEIGHTS;
    const total =
        W.scent       * s_scent
      + W.climate     * s_climate
      + W.occasion    * s_occasion
      + W.intensity   * s_intensity
      + W.personality * s_person
      + W.style       * s_style
      + W.daypart     * s_daypart
      + W.purchase_intent * s_intent;

    return {
      total,
      subscores: { s_scent, s_climate, s_occasion, s_intensity, s_person, s_style, s_daypart, s_intent },
    };
  }

  function derivedSignals(userProfile) {
    const dual = userProfile.explorationMode === "diario_especial" || userProfile.explorationMode === "variar_mood";
    return {
      dualPurchaseIntent: dual,
      seeksLuxury:   userProfile.purchaseIntent === "lujoso" || (userProfile.scentPreference || []).includes("elegante"),
      seeksSafe:     userProfile.purchaseIntent === "facil_usar" || userProfile.explorationMode === "firma_unica",
    };
  }

  /* ======================================================================
     Candidate selection: anchor / versatile / complement
     ====================================================================== */
  function pickTriad(fragrances, userProfile) {
    const active = fragrances.filter(f => f.active !== false);
    const gender = userProfile.genderFilter; // "hombres" | "mujeres" | "unisex"
    // "unisex" from the user means "sin preferencia" — show the full catalog.
    // "hombres" / "mujeres" filter by Shopify collection membership (source of truth).
    const filtered = active.filter(f => {
      if (!gender || gender === "unisex") return true;
      const cols = f.collections || [];
      if (cols.length === 0) return true; // orphans: show to everyone rather than hide
      return cols.includes(gender);
    });

    const scored = filtered.map(f => ({ ...f, _score: scoreFragrance(f, userProfile) }));
    scored.sort((a, b) => {
      if (b._score.total !== a._score.total) return b._score.total - a._score.total;
      return (b.popularity_score || 0) - (a.popularity_score || 0);
    });

    const pool = scored.slice(0, 20);
    if (pool.length < 3) return scored.slice(0, 3); // degraded but safe

    const anchor = pool[0];

    // versatile: high total + versatility bonus
    let versatile = null, bestVScore = -Infinity;
    for (const f of pool) {
      if (f.code === anchor.code) continue;
      const v = (f._score.total) + 0.15 * ((f.versatility_score || 3) / 5);
      if (v > bestVScore) { bestVScore = v; versatile = f; }
    }
    if (!versatile) versatile = pool[1];

    // complement: optimize pairing fit
    let complement = null, bestC = -Infinity;
    const anchorFamily = new Set(anchor.olfactory_family || []);
    const anchorOcc    = new Set(anchor.occasion_fit || []);
    for (const f of pool) {
      if (f.code === anchor.code || f.code === versatile.code) continue;
      const famDisjoint = !(f.olfactory_family || []).some(x => anchorFamily.has(x));
      const newOccasion = (f.occasion_fit || []).some(x => !anchorOcc.has(x));
      const c = (f._score.total * 0.7)
              + (famDisjoint ? 0.10 : 0)
              + (newOccasion ? 0.05 : 0)
              + 0.10 * (f.popularity_score || 0);
      if (c > bestC) { bestC = c; complement = f; }
    }
    if (!complement) complement = pool[2];

    return { anchor, versatile, complement, pool };
  }

  /* ======================================================================
     Reason chips — deterministic from subscores
     ====================================================================== */
  function reasonsFor(f, userProfile) {
    const s = f._score.subscores;
    const out = [];
    if (s.s_scent >= 0.9) out.push("Coincide con tu perfil olfativo");
    if (s.s_climate === 1.0 && userProfile.climatePreference !== "versatil")
      out.push(`Perfecta para clima ${userProfile.climatePreference}`);
    if (s.s_occasion === 1.0 && userProfile.usageOccasion !== "versatil")
      out.push(`Pensada para ${prettyOccasion(userProfile.usageOccasion)}`);
    if ((f.compliment_factor || 0) >= 4) out.push("Cumplidos garantizados");
    if ((f.luxury_factor || 0) >= 4) out.push("Huele a lujo");
    if ((f.versatility_score || 0) >= 4) out.push("Súper versátil");
    if ((f.popularity_score || 0) >= 0.5) out.push("Top más vendido");
    if (f.inspiration_brand) out.push(`Inspirada en ${f.inspiration_brand}`);
    return out.slice(0, 3);
  }
  function prettyOccasion(v) {
    return {
      diario: "el día a día", oficina: "oficina/universidad",
      citas: "citas", noche: "salidas de noche", eventos: "eventos especiales", versatil: "cualquier ocasión",
    }[v] || v;
  }

  /* ======================================================================
     Analytics
     ====================================================================== */
  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...payload });
    } catch (_) { /* noop */ }
  }

  /* ======================================================================
     Quiz engine / renderer
     ====================================================================== */
  class FragranceQuiz {
    constructor(root) {
      this.root = root;
      this.settings = {
        datasetUrl: root.dataset.datasetUrl,
        introHeadline: root.dataset.introHeadline || "Descubre las <em>3 fragancias</em> Serené que más van contigo.",
        introSub: root.dataset.introSub || "Un test de 90 segundos te revela tus matches entre 117 fragancias. Personalizado, editorial, hecho para ti.",
        introCta: root.dataset.introCta || "Empezar mi test",
        heroImage: root.dataset.heroImage || "",
        promoTitle: root.dataset.promoTitle || "Lleva 2 de tus recomendadas en 10 ml por $120.000",
        promoSub: root.dataset.promoSub || "Prueba dos moods distintos — una para tu día a día y otra para ocasiones especiales.",
        dualCta: root.dataset.dualCta || "Llevar mis 2 favoritas",
        singleCta: root.dataset.singleCta || "Comprar mi match principal",
        discountCode: root.dataset.discountCode || "",
        promoVariantMap: safeJson(root.dataset.promoVariantMap) || {},
      };
      this.data = [];
      this.state = {
        step: 0, // 0 = intro, 1..QUESTIONS.length = questions, +1 = processing, +2 = results
        answers: {},
        triad: null,
      };
      this.savedState = null; // set in init() if sessionStorage has a completed run
      this._processingIntervals = [];
      this.init();
    }

    /* ---------- State persistence (sessionStorage) ---------- */
    _storageKey() { return "seFragranceQuizState_v1"; }

    loadSavedState() {
      try {
        const raw = sessionStorage.getItem(this._storageKey());
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.triad || !parsed.answers) return null;
        return parsed;
      } catch { return null; }
    }

    saveState() {
      try {
        sessionStorage.setItem(this._storageKey(), JSON.stringify({
          answers: this.state.answers,
          triad: this.state.triad,
          signals: this.state.signals,
          savedAt: Date.now(),
        }));
      } catch (_) { /* storage disabled */ }
    }

    clearSavedState() {
      try { sessionStorage.removeItem(this._storageKey()); } catch (_) {}
    }

    restoreFromSaved() {
      if (!this.savedState) return;
      this.state.answers = this.savedState.answers;
      this.state.triad = this.savedState.triad;
      this.state.signals = this.savedState.signals || derivedSignals(this.savedState.answers);
      this.state.step = QUESTIONS.length + 2; // jump straight to results
      this.render();
      track("results_resumed");
    }

    async init() {
      try {
        const res = await fetch(this.settings.datasetUrl);
        this.data = await res.json();
      } catch (e) {
        console.error("[FragranceQuiz] failed to load dataset", e);
        this.root.innerHTML = `<div class="se-quiz__inner"><p>Estamos configurando el test. Intenta de nuevo en un momento.</p></div>`;
        return;
      }
      this.savedState = this.loadSavedState();
      this.render();
    }

    goTo(step) {
      this.state.step = step;
      this.render();
      this.root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    render() {
      // Clear any running intervals from processing screen
      this._processingIntervals.forEach(clearInterval);
      this._processingIntervals = [];

      const s = this.state.step;
      let html;
      if (s === 0) html = this.tplIntro();
      else if (s >= 1 && s <= QUESTIONS.length) html = this.tplQuestion(s - 1);
      else if (s === QUESTIONS.length + 1) html = this.tplProcessing();
      else html = this.tplResults();

      this.root.innerHTML = `<div class="se-quiz__inner">${html}</div>`;
      this.bind();
    }

    bind() {
      // Intro CTA
      this.root.querySelectorAll("[data-action='start']").forEach(el => {
        el.addEventListener("click", () => {
          track("quiz_started", { quiz: "fragrance-quiz" });
          this.goTo(1);
        });
      });
      // Option select
      this.root.querySelectorAll("[data-action='select']").forEach(btn => {
        btn.addEventListener("click", () => this.onSelect(btn));
      });
      // Next / Back
      this.root.querySelectorAll("[data-action='next']").forEach(btn => {
        btn.addEventListener("click", () => this.onNext());
      });
      this.root.querySelectorAll("[data-action='back']").forEach(btn => {
        btn.addEventListener("click", () => this.goTo(Math.max(0, this.state.step - 1)));
      });
      this.root.querySelectorAll("[data-action='restart']").forEach(btn => {
        btn.addEventListener("click", () => {
          this.clearSavedState();
          this.savedState = null;
          this.state = { step: 0, answers: {}, triad: null };
          track("quiz_restarted");
          this.goTo(0);
        });
      });
      this.root.querySelectorAll("[data-action='resume']").forEach(btn => {
        btn.addEventListener("click", () => this.restoreFromSaved());
      });
      // Card CTA (buy single)
      this.root.querySelectorAll("[data-action='buy-single']").forEach(btn => {
        btn.addEventListener("click", () => this.onBuySingle(btn.dataset.code));
      });
      // Dual promo CTA
      this.root.querySelectorAll("[data-action='buy-dual']").forEach(btn => {
        btn.addEventListener("click", () => this.onBuyDual());
      });
    }

    onSelect(btn) {
      const qIdx = this.state.step - 1;
      if (qIdx < 0 || qIdx >= QUESTIONS.length) return;
      const q = QUESTIONS[qIdx];
      const value = btn.dataset.value;

      // When gender changes, clear personalityType so a stale feminine/masculine
      // answer from a previous run doesn't carry over to the wrong option set.
      if (q.id === "genderFilter" && this.state.answers.genderFilter !== value) {
        delete this.state.answers.personalityType;
      }

      if (q.kind === "multi") {
        const cur = new Set(this.state.answers[q.id] || []);
        if (cur.has(value)) cur.delete(value);
        else {
          if (q.max && cur.size >= q.max) return; // cap
          cur.add(value);
        }
        this.state.answers[q.id] = Array.from(cur);
      } else {
        this.state.answers[q.id] = value;
      }
      this.render();
    }

    onNext() {
      const qIdx = this.state.step - 1;
      if (qIdx >= 0 && qIdx < QUESTIONS.length) {
        const q = QUESTIONS[qIdx];
        track("question_answered", { quiz: "fragrance-quiz", question: q.id, answer: this.state.answers[q.id] });
      }
      if (this.state.step === QUESTIONS.length) {
        // compute triad now, show processing, then results
        this.state.triad = pickTriad(this.data, this.state.answers);
        this.state.signals = derivedSignals(this.state.answers);
        this.state.step = QUESTIONS.length + 1;
        this.render();
        setTimeout(() => {
          track("quiz_completed", {
            quiz: "fragrance-quiz",
            anchor: this.state.triad.anchor.code,
            versatile: this.state.triad.versatile.code,
            complement: this.state.triad.complement.code,
          });
          this.state.step = QUESTIONS.length + 2;
          this.saveState(); // persist so user can come back
          this.savedState = this.loadSavedState();
          this.render();
          track("results_viewed");
        }, 2400);
      } else {
        this.goTo(this.state.step + 1);
      }
    }

    /* ---------- Cart helpers ---------- */
    async addToCart(items) {
      // Use Shopify AJAX Cart API; requires /cart/add.js available on the storefront.
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error("cart_add_failed");
        return await res.json();
      } catch (e) {
        console.error("[FragranceQuiz]", e);
        return null;
      }
    }

    async onBuySingle(code) {
      const f = this.data.find(x => x.code === code);
      if (!f) return;
      const vid = numericId(f.variants && f.variants.primary_100ml && f.variants.primary_100ml.variant_id);
      track("recommendation_clicked", { code, format: "100ml" });
      track("add_to_cart_from_quiz", { code, format: "100ml" });
      if (!vid) { window.location.href = f.url; return; }
      const ok = await this.addToCart([{ id: vid, quantity: 1 }]);
      if (ok) window.location.href = "/cart";
      else    window.location.href = f.url;
    }

    async onBuyDual() {
      const { anchor, complement } = this.state.triad;
      track("dual_promo_clicked", { anchor: anchor.code, complement: complement.code });

      // Promo variant map: merchant-configured per code, e.g. {"S030": 1234567890}.
      // If missing, fall back to the 50ml kit variant (closest to the promo format).
      // If that's also missing, fall back to 100ml primary.
      const getPromoVariant = f => {
        const mapped = this.settings.promoVariantMap[f.code];
        if (mapped) return mapped;
        if (f.variants && f.variants.kit_50ml && f.variants.kit_50ml.variant_id) return numericId(f.variants.kit_50ml.variant_id);
        return numericId(f.variants && f.variants.primary_100ml && f.variants.primary_100ml.variant_id);
      };

      const vA = getPromoVariant(anchor);
      const vB = getPromoVariant(complement);
      if (!vA || !vB) { window.location.href = complement.url; return; }

      track("add_to_cart_from_quiz", { codes: [anchor.code, complement.code], format: "dual" });
      const ok = await this.addToCart([
        { id: vA, quantity: 1 },
        { id: vB, quantity: 1 },
      ]);
      if (!ok) { window.location.href = "/cart"; return; }

      if (this.settings.discountCode) {
        window.location.href = `/discount/${encodeURIComponent(this.settings.discountCode)}?redirect=/cart`;
      } else {
        window.location.href = "/cart";
      }
    }

    /* ---------- Templates ---------- */
    tplProgress() {
      const total = QUESTIONS.length;
      let cur = 0;
      if (this.state.step >= 1 && this.state.step <= total) cur = this.state.step;
      else if (this.state.step > total) cur = total;
      const pct = cur === 0 ? 0 : (cur / total) * 100;
      const showBack = this.state.step >= 2 && this.state.step <= total;
      return `
        <div class="se-quiz__step-indicator">
          <span>${cur === 0 ? "Test de fragancia" : `Paso ${cur} de ${total}`}</span>
          ${showBack ? `<button type="button" data-action="back">← Anterior</button>` : ""}
        </div>
        <div class="se-quiz__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(pct)}">
          <div class="se-quiz__progress-bar" style="width:${pct}%"></div>
        </div>
      `;
    }

    tplIntro() {
      const hasSaved = !!this.savedState;
      const anchorName = hasSaved && this.savedState.triad && this.savedState.triad.anchor
        ? shortName(this.savedState.triad.anchor) : "";
      return `
        <div class="se-quiz__screen">
          ${this.tplProgress()}
          <div class="se-quiz__intro-grid">
            <div class="se-quiz__intro-copy">
              <span class="se-quiz__kicker">Test de Fragancia Serené</span>
              <h1>${this.settings.introHeadline}</h1>
              <p>${this.settings.introSub}</p>
              <div class="se-quiz__intro-ctas">
                <button class="se-btn se-btn--primary" type="button" data-action="start">
                  ${this.settings.introCta} →
                </button>
                ${hasSaved ? `
                  <button class="se-btn se-btn--ghost" type="button" data-action="resume">
                    ${iconBookmark()} Volver a mis 3 matches${anchorName ? ` · ${escapeHtml(anchorName)}` : ""}
                  </button>
                ` : ""}
              </div>
              <div class="se-quiz__intro-meta">
                <span>${iconClock()} ~90 segundos</span>
                <span>${iconSparkle()} 117 fragancias analizadas</span>
                <span>${iconGift()} 3 matches para ti</span>
              </div>
            </div>
            <div class="se-quiz__intro-visual">
              ${this.settings.heroImage ? `<img src="${escapeHtml(this.settings.heroImage)}" alt="">` : ""}
            </div>
          </div>
        </div>
      `;
    }

    tplQuestion(qIdx) {
      const q = QUESTIONS[qIdx];
      // Resolve gender-specific options when available (e.g. personalityType)
      const gender = this.state.answers.genderFilter;
      const opts = (q.optionsByGender && gender && q.optionsByGender[gender])
        ? q.optionsByGender[gender]
        : q.options;
      const ans = this.state.answers[q.id];
      const isSelected = (v) => q.kind === "multi" ? (ans || []).includes(v) : ans === v;
      const canAdvance = q.kind === "multi" ? (ans || []).length >= 1 : !!ans;
      const gridClass = opts.length <= 4 ? "se-quiz__options se-quiz__options--two"
                                         : opts.length <= 6 ? "se-quiz__options se-quiz__options--three"
                                         : "se-quiz__options";
      const multiHint = q.kind === "multi"
        ? `<span class="se-quiz__nav-meta">${(ans || []).length}/${q.max || opts.length} seleccionadas</span>`
        : "";
      return `
        <div class="se-quiz__screen">
          ${this.tplProgress()}
          <div class="se-quiz__q-header">
            <h2 class="se-quiz__q-title">${q.title}</h2>
            ${q.sub ? `<div class="se-quiz__q-sub">${q.sub}</div>` : ""}
          </div>
          <div class="${gridClass}">
            ${opts.map(o => `
              <button type="button" class="se-quiz__opt" data-action="select" data-value="${o.value}"
                      aria-pressed="${isSelected(o.value)}">
                <div class="se-quiz__opt-check">${iconCheck()}</div>
                <div class="se-quiz__opt-emoji" aria-hidden="true">${o.emoji || ""}</div>
                <div>
                  <div class="se-quiz__opt-label">${o.label}</div>
                  ${o.hint ? `<span class="se-quiz__opt-hint">${o.hint}</span>` : ""}
                </div>
              </button>
            `).join("")}
          </div>
          <div class="se-quiz__nav">
            ${multiHint}
            <button class="se-btn se-btn--primary" type="button" data-action="next" ${canAdvance ? "" : "disabled"}>
              ${qIdx === QUESTIONS.length - 1 ? "Ver mis matches" : "Siguiente"} →
            </button>
          </div>
        </div>
      `;
    }

    tplProcessing() {
      const msgs = [
        "Analizando tu estilo…",
        "Cruzando 117 fragancias…",
        "Buscando tus matches ideales…",
        "Afinando tu Top 3 Serené…",
      ];
      // Rotate message every 650ms
      const id = "se-quiz-proc-" + Math.random().toString(36).slice(2, 8);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (!el) return;
        let i = 0;
        const int = setInterval(() => {
          i = (i + 1) % msgs.length;
          el.textContent = msgs[i];
          el.style.animation = "none"; void el.offsetWidth; el.style.animation = "";
        }, 650);
        this._processingIntervals.push(int);
      }, 30);
      return `
        <div class="se-quiz__screen se-quiz__processing">
          <div class="se-quiz__ring" aria-hidden="true"></div>
          <div class="se-quiz__processing-msg" id="${id}">${msgs[0]}</div>
        </div>
      `;
    }

    tplResults() {
      const { anchor, versatile, complement } = this.state.triad;
      const signals = this.state.signals || {};
      const primaryCta = signals.dualPurchaseIntent
        ? { label: this.settings.dualCta, action: "buy-dual" }
        : { label: this.settings.singleCta, action: "buy-single", code: anchor.code };

      const card = (f, role, extraClass) => {
        const reasons = reasonsFor(f, this.state.answers);
        const priceStr = f.variants && f.variants.primary_100ml
          ? formatCOP(f.variants.primary_100ml.price)
          : "";
        return `
          <article class="se-quiz__card ${extraClass}">
            ${role ? `<div class="se-quiz__card-role">${role}</div>` : ""}
            <div class="se-quiz__card-image">
              ${f.image_url ? `<img src="${escapeHtml(f.image_url)}" alt="${escapeHtml(f.title)}" loading="lazy">` : ""}
            </div>
            <div class="se-quiz__card-title">${escapeHtml(shortName(f))}</div>
            ${f.inspiration_brand ? `<div class="se-quiz__card-insp">Inspirada en ${escapeHtml(f.inspiration_name || "")} · ${escapeHtml(f.inspiration_brand)}</div>` : ""}
            <div class="se-quiz__chips">
              ${reasons.map((r, i) => `<span class="se-quiz__chip${i===0?" se-quiz__chip--hot":""}">${escapeHtml(r)}</span>`).join("")}
            </div>
            <div class="se-quiz__card-cta">
              <button class="se-btn se-btn--primary se-btn--block" type="button" data-action="buy-single" data-code="${f.code}">
                Llevarla ${priceStr ? `· ${priceStr}` : ""}
              </button>
              <a class="se-quiz__card-link" href="${escapeHtml(f.url)}">Ver ficha completa</a>
            </div>
          </article>
        `;
      };

      return `
        <div class="se-quiz__screen">
          <div class="se-quiz__results-header">
            <span class="se-quiz__kicker">Tus 3 matches Serené</span>
            <h2>Estas fragancias van contigo.</h2>
            <p>Seleccionamos tu anchor, la más versátil, y un complemento para alternar según tu mood.</p>
          </div>
          <div class="se-quiz__cards">
            ${card(anchor,    "",                              "se-quiz__card--anchor")}
            ${card(versatile, "Tu opción más versátil",        "")}
            ${card(complement,"Tu complemento ideal",          "")}
          </div>
          <div class="se-quiz__promo">
            <div>
              <div class="se-quiz__promo-title">${escapeHtml(this.settings.promoTitle)}</div>
              <div class="se-quiz__promo-sub">${escapeHtml(this.settings.promoSub)}</div>
            </div>
            <button class="se-btn se-btn--primary" type="button" data-action="${primaryCta.action}" ${primaryCta.code ? `data-code="${primaryCta.code}"` : ""}>
              ${escapeHtml(primaryCta.label)} →
            </button>
          </div>
          <div class="se-quiz__actions">
            <button class="se-btn se-btn--ghost" type="button" data-action="restart">
              ${iconRefresh()} Descubrir otro mood olfativo
            </button>
            <span class="se-quiz__actions-hint">Tus matches actuales se guardan mientras estás en la tienda.</span>
          </div>
        </div>
      `;
    }
  }

  /* ---------- Helpers ---------- */
  function numericId(gid) {
    if (!gid) return null;
    if (typeof gid === "number") return gid;
    const m = String(gid).match(/(\d+)$/);
    return m ? Number(m[1]) : null;
  }
  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  }
  function safeJson(s) { try { return JSON.parse(s); } catch { return null; } }
  function formatCOP(v) {
    const n = Number(v);
    if (!isFinite(n)) return "";
    return "$" + n.toLocaleString("es-CO", { maximumFractionDigits: 0 });
  }
  function shortName(f) {
    // "Serené Le Parfum S030 - inspirada en..." -> "Serené S030"
    const m = /S\d{3}/.exec(f.title);
    return m ? `Serené ${m[0]}` : f.title;
  }
  function iconCheck() {
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;
  }
  function iconClock() { return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>`; }
  function iconSparkle() { return `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2zM19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14zM5 15l.6 1.6L7 17l-1.4.4L5 19l-.6-1.6L3 17l1.4-.4L5 15z"/></svg>`; }
  function iconGift() { return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="13" rx="1"/><path d="M3 12h18M12 8v13M12 8c-2 0-4-1-4-3s1.5-2 3-1 1 3 1 4z M12 8c2 0 4-1 4-3s-1.5-2-3-1-1 3-1 4z"/></svg>`; }
  function iconBookmark() { return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M6 3h12v18l-6-4-6 4z"/></svg>`; }
  function iconRefresh() { return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>`; }

  /* ---------- Auto-init ---------- */
  function init() {
    document.querySelectorAll("[data-fragrance-quiz]").forEach(el => {
      if (el.__seQuizInit) return;
      el.__seQuizInit = true;
      new FragranceQuiz(el);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
